var map = {
	"./developer-tool-icon.svg": 6843,
	"./email-provider/amazon_ses.svg": 9557,
	"./email-provider/google.svg": 1922,
	"./email-provider/outlook.svg": 2345,
	"./email-provider/sendgrid.svg": 1026,
	"./email-provider/sendinblue.svg": 5398,
	"./email-provider/smtp.svg": 7687,
	"./expand-icon.svg": 4337,
	"./wrapper-icon.svg": 6338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2516;